import { render } from "./PostListPage.vue?vue&type=template&id=652cb315&ts=true"
import script from "./PostListPage.vue?vue&type=script&lang=ts"
export * from "./PostListPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__